const useTheme = (themeBool = false) => {
  const theme = themeBool ? 'light' : 'dark'
  const invertTheme = themeBool ? 'dark' : 'light'
  return { theme, invertTheme }
}
export default useTheme
